<template>
  <nav class="navbar navbar-expand-lg bg-light fixed-top">
    <div class="container">
      <a class="navbar-brand" href="#"
        ><img src="../assets/Images/footer-logo.png" class="img-fluid" alt=""
      /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item" v-for="(route, index) in routes" :key="index">
            <router-link
              :class="['items', { active: route.path === $route.path }]"
              :to="route.path"
              >{{ route.label }}</router-link
            >
          </li>
          <li class="nav-contact">
            <router-link class="btn btn-primary" to="#"
              >Buy A Course</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      routes: [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About Us' },
        { path: '/service', label: 'Services' },
        { path: '/training', label: 'Training' },
        { path: '/co-workspace', label: 'Co-Workspace' },
      ]
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.navbar {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.navbar .nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.items {
  text-decoration: none;
  color: #404040;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  display: block;
}

.active {
  color: #006EC3;
  font-weight: 700;
}

.header {
  padding: 10px 0px;
}

.navbar-nav li {
  text-decoration-style: none;
  margin-left: 20px;
  padding: 10px 20px;
}

/* .nav-contact{
  background-color:  #335CA6;
  border-radius: 10px;
  margin-right: 15px;
  transition: 1.2ms;

} */

/* .nav-contact:hover{
  background-color: #ffffff;
  transition: 1.2ms;
  color: #404040;
  border: 1px solid #404040;
} */

.contact-text {
  text-decoration: none;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  transition: 1.2ms;
}

.contact-text:hover {
  color: #404040;
}

/* Respoviveness */
@media screen and (max-width: 770px) {
  li {
    margin-top: 10px;
    padding: 7px 7px;
  }

  /* .nav-contact {
    display: none;
  } */

  .navbar .nav-item {
    display: block;
  }
}

@media screen and (max-width: 430px) {
  /* .nav-contact{
  width: 30%;
 } */

 .navbar-nav li {
  margin-left: 0;
 }
}
</style>
